import { render, staticRenderFns } from "./NewLogin.vue?vue&type=template&id=4bb4d84a&scoped=true"
import script from "./NewLogin.vue?vue&type=script&lang=ts"
export * from "./NewLogin.vue?vue&type=script&lang=ts"
import style0 from "./NewLogin.vue?vue&type=style&index=0&id=4bb4d84a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4d84a",
  null
  
)

export default component.exports